import { ONBOARDING_SECTIONS } from "@pages/onboarding/onboardingSteps"
import { WHATSAPP_SECTIONS } from "@pages/onboarding/whatsapp/whatsappSteps"
import { ReactNode } from "react"
import { useLocation } from "react-router-dom"
import ProgressBar from "./ProgressBar"

interface Props {
  children: ReactNode
}

export default function Layout({ children }: Props) {
  const location = useLocation()
  const isOnboardingRoute = location.pathname.startsWith("/onboarding")
  const isWhatsappFunnel = location.pathname.startsWith("/onboarding/whatsapp")

  const isInterstitialPage =
    location.pathname.includes("socialProof") ||
    location.pathname.includes("restrictiveDiets") ||
    location.pathname.includes("sustainableApproach") ||
    location.pathname.includes("challengesOvercome") ||
    location.pathname.includes("motivational") ||
    location.pathname.includes("calorieCountingPositive") ||
    location.pathname.includes("valueProp") ||
    location.pathname.includes("aiFeature") ||
    location.pathname.includes("/almostThere") ||
    location.pathname.includes("whatsAppTracking") ||
    location.pathname.includes("whatsAppCoaching") ||
    location.pathname.includes("whatsAppDemo") ||
    location.pathname.includes("whatsAppCoachingDemo") ||
    location.pathname.includes("wellnessSnapshot") ||
    location.pathname.includes("lookForwardTo") ||
    location.pathname.includes("progressPlan")

  const isAuthPage =
    location.pathname.includes("/email") ||
    location.pathname.includes("/password")

  const isLandingPage = location.pathname.includes("chooseGoal")

  const showProgressBar =
    isOnboardingRoute && !isInterstitialPage && !isAuthPage && !isLandingPage

  const sections = isWhatsappFunnel ? WHATSAPP_SECTIONS : ONBOARDING_SECTIONS
  const basePath = isWhatsappFunnel ? "/onboarding/whatsapp" : "/onboarding"

  return (
    <main className="custom-container flex min-h-dvh flex-col gap-4 pt-4 pb-8">
      {showProgressBar && (
        <div className="mb-2">
          <ProgressBar sections={sections} basePath={basePath} />
        </div>
      )}
      {children}
    </main>
  )
}
